import { combineReducers } from 'redux';
import player from './user';

const rootReducer = combineReducers({ player });
export default rootReducer;
